import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBYRVSGXQWOVsY4VlUEC8pNVlBKAiV_6pI",
  authDomain: "woundcareprd.firebaseapp.com",
  projectId: "woundcareprd",
};


firebase.initializeApp(firebaseConfig);

export default firebase;